import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { ANALYTICS_MODULES } from '../../../config/constants/analytics-v2';
import { makeSelectProperty } from '../selectors';
import Cash from './Cash';
import Operations from './Operations';
import Orders from './Orders';
import Overview from './Overview';
import Promo from './Promo';
import Sales from './Sales';

const Module = ({ selectedTab }) => {
  if (selectedTab === ANALYTICS_MODULES.OVERVIEW) {
    return <Overview />;
  }
  if (selectedTab === ANALYTICS_MODULES.SALES) {
    return <Sales />;
  }
  if (selectedTab === ANALYTICS_MODULES.OPERATIONS) {
    return <Operations />;
  }
  if (selectedTab === ANALYTICS_MODULES.PROMO) {
    return <Promo />;
  }
  if (selectedTab === ANALYTICS_MODULES.ORDERS) {
    return <Orders />;
  }
  if (selectedTab === ANALYTICS_MODULES.CASH) {
    return <Cash />;
  }

  return null;
};

Module.propTypes = {
  selectedTab: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  selectedTab: makeSelectProperty('selectedTab'),
});

const withConnect = connect(mapStateToProps);

export default compose(withConnect)(Module);
